<div class="job-issue-list-container"
     data-testid="job-issue-list-container">
    @if (dataLoaded) {
        <schedule-detail-header [title]="'Needs Attention'"
                                [subtitle]="areaComponentSubtitle()"
                                [backCallback]="goBack.bind(this)"
                                [showCloud]="true"
                                [isRefreshingInBackground]="isRefreshingInBackground()" />
        <div class="title-bar">
            <div [innerHTML]="assertion().text"
                 class="title-text"
                 data-testid="job-issue-list-text-assertion">
                {{assertion().text}}
            </div>
        </div>
        <div class="issue-list-container"
             [appDataUpdatedFade]="dataUpdatedPulse()"
             data-testid="job-issue-list-issues">
            <div class="issue-list-count"
                 data-testid="job-issue-list-count">
                Recorded {{issues().length > 1 ? "Issues" : "Issue"}} ({{issues().length}})
            </div>
            <div class="issues-list"
                 data-testid="job-issue-list">
                @for (issue of issues(); track issue.id) {
                    <div class="issue-card"
                         (click)="editIssue(issue)"
                         data-testid="job-issue-list-item">
                        <div class="issue-note">{{issue.text}}</div>
                        <div>
                            <div class="pi pi-chevron-right"></div>
                        </div>
                    </div>
                    <div class="issue-separator"
                         [style.visibility]="$last ? 'hidden' : 'visible'"></div>
                }
            </div>
        </div>
        <div class="buttons-container">
            <button class="submit-button"
                    (click)="addNewIssue()"
                    data-testid="job-issue-list-btn-add">
                Add New Issue
            </button>
            <button class="cancel-button"
                    (click)="goBack()"
                    data-testid="job-issue-list-btn-return">
                <a class="body-md-medium"> Return to List </a>
            </button>
        </div>
    }
</div>